<template lang="pug">
    page(:loading="$wait.waiting([keys.objects.read, keys.objectTypes.read, keys.objects.business_types])" like-form)
        template(#title="")
            v-layout(wrap align-center justify-space-between)
                v-flex(grow)
                    e-typography-heading-1 {{ object.name }}

                m-block-object-actions(v-if="!$lodash.isEmpty(object)" :item="object" :deleted="deleted" viewType="view")

            v-layout(wrap)
                v-flex(xs12)
                    e-divider-secondary

        template(#content="" v-if="objectLoaded")
            m-block-object-type(:item="object")
            m-block-object-workplace-info(:item="object")
            m-block-object-contact-person(:item="object")
            m-block-object-profile-workplace(:item="object")
</template>

<script>
    import basePage from "@mixins/components/pages/base";
    import MBlockObjectType from "@modules/blocks/page/concrete/m-block-object-type";
    import MBlockObjectActions from "@modules/blocks/actions/concrete/m-block-object-actions";
    import MBlockObjectContactPerson from "@modules/blocks/page/concrete/m-block-object-contact-person";
    import MBlockObjectWorkplaceInfo from "@modules/blocks/page/concrete/m-block-object-workplace-info";
    import MBlockObjectProfileWorkplace from "@modules/blocks/page/concrete/m-block-object-profile-workplace";
    import errorHandler from "@mixins/responses/_errorHandler";
    import notifications from "@mixins/includes/_notifications";

    import {mapActions, mapGetters} from 'vuex';

    let name = 'dashboard-service-objects-view';
    export default {
        name: name,
        components: {
            MBlockObjectProfileWorkplace,
            MBlockObjectWorkplaceInfo,
            MBlockObjectContactPerson,
            MBlockObjectType,
            MBlockObjectActions
        },
        mixins: [basePage, errorHandler, notifications],
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.service.objects.view.meta.title')
            }
        },
        props: {
            name: {
                type: String,
                default: name
            }
        },
        async created() {
            try {
                await this.requestObject();
                await Promise.all([
                    this.requestObjectType({id: this.object._jv.relationships.objectType.data.id}),
                    this.requestObjectBusinessTypes({id: this.object._id}),
                    this.requestObjectModerators({id: this.object._id})
                ]);
            } catch (e) {
                this.error.handle(e)
            }
            this.$iBreadcrumbs.setText(this.object.name);
        },
        computed: {
            ...mapGetters({
                getObject: 'objects/read'
            }),

            object() {
                return this.getObject(this.$route.params.id);
            },
            objectLoaded() {
                return Object.keys(this.object).length > 0
            }
        },
        methods: {
            ...mapActions({
                loadObject: 'objects/read',
                requestObjectType: 'objectTypes/read',
                requestObjectBusinessTypes: 'objects/business_types',
                requestObjectModerators: 'objects/moderators'
            }),

            requestObject() {
                return this.loadObject({
                    id: this.$route.params.id
                });
            },

            deleted() {
                this.notify.success(this.$t('notifications.objects.deleted'));
                this.redirect(this.nav.dashboard.service.objects.index.name);
            }
        }
    }
</script>

<style scoped>

</style>
